module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_05",
      "id": "CC_05"
    }
  }, [_c('i', [_vm._v("The Andy Griffith Show")])])]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('i', [_vm._v("Cast")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("Andy Griffith—Andy Taylor ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-4"
    }
  }, [_vm._v("Don Knotts—Barney Fife ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-5"
    }
  }, [_vm._v("Ron Howard—Opie Taylor ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-6"
    }
  }, [_vm._v("Frances Bavier—Aunt Bee Taylor ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-7"
    }
  }, [_vm._v("Howard McNear—Floyd Lawson ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-8"
    }
  }, [_vm._v("Hal Smith—Otis Campbell ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-9"
    }
  }, [_vm._v("Betty Lynn—Thelma Lou ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-10"
    }
  }, [_vm._v("Aneta Corsaut—Helen Crump ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-11"
    }
  }, [_vm._v("Jim Nabors—Gomer Pyle ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-12"
    }
  }, [_vm._v("George Lindsey—Goober Pyle ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-13"
    }
  }, [_vm._v("Jack Dodson—Howard Sprague ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-14"
    }
  }, [_vm._v("Paul Hartman—Emmett Clark ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-15"
    }
  }, [_vm._v("Jack Burns—Warren Ferguson ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-16"
    }
  }, [_vm._v("Hope Summers—Clara Edwards Johnson ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-17"
    }
  }, [_vm._v("Denver Pyle—Briscoe Darling ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-18"
    }
  }, [_vm._v("Maggie Ann Peterson—Charlene Darling ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-19"
    }
  }, [_vm._v("The Dillards (Doug Dillard, Rodney Dillard, Mitch Jayne, and Dean Webb)—The Darling Boys ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-21"
    }
  }, [_vm._v("Howard Morris—Ernest T. Bass ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-22"
    }
  }, [_vm._v("Elinor Donahue—Ellie Walker ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-23"
    }
  }, [_vm._v("Jack Prince—Rafe Hollister ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-24"
    }
  }, [_vm._v("Dick Elliot—Mayor Pike ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-25"
    }
  }, [_vm._v("Parley Baer—Mayor Roy Stoner ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-26"
    }
  }, [_vm._v("Ken Berry—Sam Jones ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-27"
    }
  }, [_vm._v("Arlene Golonka—Millie Hutchins ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-28"
    }
  }, [_vm._v("Buddy Foster—Mike Jones ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-29"
    }
  }, [_vm._v("Joyce Jameson—Fun Girl Skippy ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-30"
    }
  }, [_vm._v("Jean Carson—Fun Girl Daphne and escaped convict Naomi ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-31"
    }
  }, [_vm._v("Dennis Rush—Howie Pruitt/Williams ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-32"
    }
  }, [_vm._v("Sheldon Golomb—Arnold Bailey ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-33"
    }
  }, [_vm._v("Richard Keith (Keith Thibodeaux)—Johnny Paul Jason ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-34"
    }
  }, [_vm._v("Bernard Fox—Malcolm Merriweather ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-35"
    }
  }, [_vm._v("James Best—Jim Lindsey ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-36"
    }
  }, [_vm._v("Hoke Howell—Dud Wash ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-37"
    }
  }, [_vm._v("Joanna Moore—Peggy McMillan ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-38"
    }
  }, [_vm._v("Cheerio Meredith—Emma (Watson) Brand ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-39"
    }
  }, [_vm._v("Clint Howard—Leon ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-40"
    }
  }, [_vm._v("Rance Howard—Various characters"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-41"
    }
  }, [_c('i', [_vm._v("Guest Stars")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-42"
    }
  }, [_vm._v("Jackie Joseph—Ramona Ankrum ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-43"
    }
  }, [_vm._v("Frank Sutton—Sgt. Carter ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-44"
    }
  }, [_vm._v("Charles P. Thompson—Asa Breeney ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-45"
    }
  }, [_vm._v("Enid Markey—Mrs. Mendelbright ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-46"
    }
  }, [_vm._v("Will Wright, Tol Avery, and Jason Johnson—Ben Weaver ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-47"
    }
  }, [_vm._v("Olan Soule—John Masters ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz9-48"
    }
  }, [_vm._v("Josie Lloyd—Lydia Crosswaith ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Barbara Perry—Flossie, Mary Lee, Lavinia, and Doris Williams ")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-2"
    }
  }, [_vm._v("Norman Leavitt, Trevor Bardette, and Cliff Norton—Wally ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-3"
    }
  }, [_vm._v("Jane Dulo—Escaped convict Sally ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-4"
    }
  }, [_vm._v("Barbara Eden—Ellen Brown ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-5"
    }
  }, [_vm._v("Mary Grace Canfield—Mary Grace Gossage ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-6"
    }
  }, [_vm._v("Joyce Van Patten—Laura Hollander ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-7"
    }
  }, [_vm._v("Robert Cornthwaite—Inspector Somerset ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-8"
    }
  }, [_vm._v("Alan Oppenheimer—Mr. Ruskin, the Interpreter ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-9"
    }
  }, [_vm._v("R.G. Armstrong—Farmer Flint ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-10"
    }
  }, [_vm._v("Elaine Joyce—Mavis Neff ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-11"
    }
  }, [_vm._v("The Country Boys (Roland White, LeRoy McNees, Clarence White, Eric White, and Billy Ray Latham)—Local musicians ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-13"
    }
  }, [_vm._v("Joel Redlin—Ferdie ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-14"
    }
  }, [_vm._v("Alvy Moore—Kitchenwares salesman ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-15"
    }
  }, [_vm._v("Dave Ketchum—Fred Michaels, Harry Walker ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-16"
    }
  }, [_vm._v("George Spence—Frank the fiancé ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-17"
    }
  }, [_vm._v("Brad (Joe Bolleter) Olson—Esquire Club member John Danby"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-18"
    }
  }, [_c('i', [_vm._v("Production Crew")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-19"
    }
  }, [_vm._v("Danny Thomas Productions—Production company ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-20"
    }
  }, [_vm._v("Sheldon Leonard—Executive producer ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-21"
    }
  }, [_vm._v("Richard O. Linke—Associate producer ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-22"
    }
  }, [_vm._v("Aaron Ruben—Producer and director ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-23"
    }
  }, [_vm._v("Bob Ross—Producer and director ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-24"
    }
  }, [_vm._v("Bob Sweeney—Director ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-25"
    }
  }, [_vm._v("Earle Hagen—Music director ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-26"
    }
  }, [_vm._v("Lee Greenway—Makeup ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-27"
    }
  }, [_vm._v("Frank E. Myers—Production manager ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-28"
    }
  }, [_vm._v("Ronald Jacobs—Assistant to producer ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-29"
    }
  }, [_vm._v("Sid Hickox—Director of photography ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-30"
    }
  }, [_vm._v("Ruth Burch—Casting ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-31"
    }
  }, [_vm._v("Rosemary Dorsey—Script continuity ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-32"
    }
  }, [_c('i', [_vm._v("Core Writers")])]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-33"
    }
  }, [_vm._v("Arthur Stander ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-34"
    }
  }, [_vm._v("David Adler ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-35"
    }
  }, [_vm._v("Jim Fritzell and Everett Greenbaum ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-36"
    }
  }, [_vm._v("Harvey Bullock and Ray Saffian Allen ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-37"
    }
  }, [_vm._v("Jack Elinson and Charles Stewart ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-38"
    }
  }, [_vm._v("Sam Bobrick and Bill Idelson ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-39"
    }
  }, [_vm._v("Fred S. Fox ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-40"
    }
  }, [_vm._v("Fred Freeman and Lawrence Cohen ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-41"
    }
  }, [_vm._v("Ben Joelson and Art Baer ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-42"
    }
  }, [_vm._v("Ben Gershman and Leo Solomon ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-43"
    }
  }, [_vm._v("Dick Bensfield and Perry Grant ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-44"
    }
  }, [_vm._v("Joe Bonaduce ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-45"
    }
  }, [_vm._v("Michael Morris and Seamon Jacobs ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-46"
    }
  }, [_vm._v("Aaron Ruben ")]), _vm._v(" "), _c('p', {
    staticClass: "txp",
    attrs: {
      "id": "pz10-47"
    }
  }, [_vm._v("Bob Ross ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b70e3b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter05.vue
// module id = 78
// module chunks = 0